import { createSlice, Slice } from '@reduxjs/toolkit';

type AppType = {
  mobileNav: boolean;
  pageLoading: boolean;
  redirectPath: string | null;
  printerState: { isOnline: boolean; timestamp: number };
};

const initialState: AppType = {
  mobileNav: false,
  pageLoading: true,
  redirectPath: null,
  printerState: { isOnline: true, timestamp: new Date().getTime() },
};

const appSlice: Slice<AppType> = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleMobileNav: (state) => {
      state.mobileNav = !state.mobileNav;
    },
    setPageLoading: (state, { payload }) => {
      state.pageLoading = payload;
    },
    setRedirect: (state, { payload }) => {
      state.redirectPath = payload.redirectPath;
    },
    setPrinterStatus: (state, { payload }) => {
      state.printerState.isOnline = payload.status;
      state.printerState.timestamp = new Date().getTime();
    },
  },
});

export const { toggleMobileNav, setPageLoading, setRedirect, setPrinterStatus } = appSlice.actions;
export default appSlice.reducer;
